(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tables.management', {
                parent: 'tables',
                url: '/management/:tab',
                data: {
                    authorities: ['ROLE_USER']
                    //,pageTitle: 'seatonApp.allergy.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/tables/management/management.html',
                        controller: 'TableManagementController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('tables.management');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
